import React from "react";
import {
  EmptyStateBox,
  EmptyStateTitle,
  EmptyStateText,
  StyledButton,
} from "../../Patient.styles";
import {
  VARIANTS_CONFIG,
  TEXT_WITH_BUTTON_SX,
} from "./PatientEmptyState.constants";
import { Box } from "@mui/material";

const PatientEmptyState = ({ type, onBookClick }) => {
  const config = VARIANTS_CONFIG[type];
  if (!config) return null;

  const { variant, title, text, buttonText, buttonSize, optionalMessage } =
    config;

  return (
    <EmptyStateBox variant={variant}>
      <EmptyStateTitle variant={variant}>{title}</EmptyStateTitle>
      <EmptyStateText
        variant={variant}
        sx={buttonText ? TEXT_WITH_BUTTON_SX : undefined}
      >
        {text}
      </EmptyStateText>
      {optionalMessage && (
        <EmptyStateText variant={variant} sx={{ mt: 1, fontStyle: "italic" }}>
          {optionalMessage}
        </EmptyStateText>
      )}
      {buttonText && onBookClick && (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <StyledButton
            text={buttonText}
            noIcon
            size={buttonSize}
            onClick={onBookClick}
          />
        </Box>
      )}
    </EmptyStateBox>
  );
};

export default PatientEmptyState;
